// Card and slide images (Content Showcase, sliders) whose file fails to load are removed, so
// the card shows its plain navy panel rather than the browser's broken-image icon.

const CARD_IMAGES = '.showcase-card__image, .slider-card__image, .slider-feature__image';

function removeIfBroken(image: HTMLImageElement): void {
  if (image.complete && image.naturalWidth === 0) {
    image.remove();
  }
}

export function initCardImages(): void {
  // Images that failed before this ran...
  document.querySelectorAll<HTMLImageElement>(CARD_IMAGES).forEach(removeIfBroken);

  // ...and lazy-loaded ones that fail later. Image errors do not bubble, so listen in the capture phase.
  document.addEventListener('error', (event) => {
    const target = event.target;
    if (target instanceof HTMLImageElement && target.matches(CARD_IMAGES)) {
      target.remove();
    }
  }, true);
}
